import { IAvatarAssetColorsMapVariableItemWithTestColors } from './IAvatarAssetColorsMapVariableItemWithTestColors';

export interface IAvatarAssetColorsMapVariableWithTestColors {
    colors: IAvatarAssetColorsMapVariableItemWithTestColors[];
    images: IAvatarAssetColorsMapVariableItemWithTestColors[];
}
